import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Form } from "@grandvisionhq/forms";
import { Alert, P } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import Layout from "../../../../components/Layout/components/Layout/Layout.js";
import ReturnItem from "../../../../components/ReturnItem/components/ReturnItem/ReturnItem.js";
import { useReturnItemsForm } from "../../../../hooks/hooks/use-return-items-form.js";
/* empty css                     */
const SelectItemsPage = ({
  email,
  orderNumber,
  lineItems,
  returnReasons
}) => {
  const { getLabel } = useIntl();
  const [{ isAnyCheckboxChecked, submitForm }, { loading, formState }] = useReturnItemsForm({
    email,
    orderNumber,
    lineItems,
    returnReasons
  });
  const existNotReturnableItems = lineItems?.some((item) => item.isReturnable === false);
  return /* @__PURE__ */ React.createElement(Layout, null, /* @__PURE__ */ React.createElement(Heading, { component: "h1", variant: "small" }, lineItems && lineItems?.length > 1 ? getLabel("returns.page.selectItems.title") : getLabel("returns.page.selectItems.title.singular")), existNotReturnableItems && /* @__PURE__ */ React.createElement(Alert, { className: "select-items-page__alert", variant: "info" }, getLabel("returns.page.selectItems.alert.notReturnableItems")), /* @__PURE__ */ React.createElement(
    Form,
    {
      name: "returns-request-form",
      "data-testid": "returns-request-form",
      showErrorsOnInvalidSubmit: false,
      initialFormState: formState,
      onSubmit: submitForm
    },
    lineItems?.map((lineItem, index) => /* @__PURE__ */ React.createElement(
      ReturnItem,
      {
        key: `item-${index}`,
        item: lineItem,
        id: `${index}`,
        required: !isAnyCheckboxChecked(formState),
        isOnlyItem: lineItems.length === 1,
        returnReasons,
        disabled: lineItem.isReturnable === false
      }
    )),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "select-items-page__button",
        caption: getLabel("returns.page.selectItems.submit"),
        isLoading: loading,
        disabled: loading,
        type: "submit"
      }
    )
  ), /* @__PURE__ */ React.createElement(P, { className: "select-items-page__info", variant: "text-body" }, getLabel("returns.page.selectItems.info")));
};
export {
  SelectItemsPage as default
};
//# sourceMappingURL=SelectItemsPage.js.map
